var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplaceUtglNative = function SvgReplaceUtglNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Replace_UTGL_Native_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 20H4.095v-3.759H8.07v2.316l4.837-3.134-4.837-3.156v2.316H4.095V3.759H24.75V20Zm-4.107-7.334c-.762 0-1.492.29-2.026.829a2.84 2.84 0 0 0-.84 2.003c0 .743.295 1.476.84 2.003a2.86 2.86 0 0 0 2.026.83 2.84 2.84 0 0 0 2.026-.83c.545-.538.84-1.249.84-2.003a2.82 2.82 0 0 0-.84-2.003 2.86 2.86 0 0 0-2.026-.83Zm-4.227 0c-.752 0-1.492.301-2.026.829a2.84 2.84 0 0 0-.84 2.003c0 .743.295 1.476.84 2.003.544.528 1.263.83 2.026.83.621 0 1.231-.205 1.721-.582l.24-.183-.24-.183a2.353 2.353 0 0 1 0-3.791l.24-.183-.24-.183a2.833 2.833 0 0 0-1.72-.582v.022Z",
    fill: "#305992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.635 16.241a1.91 1.91 0 0 1-1.33-.538 1.813 1.813 0 0 1-.555-1.314V1.863c0-.484.196-.97.556-1.314A1.92 1.92 0 0 1 2.635 0h17.224l1.644 1.626H2.395v12.989h1.689v1.626h-1.45Z",
    fill: "#CC8528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Replace_UTGL_Native_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.75)",
    d: "M0 0h24v20H0z"
  })))));
};
export default SvgReplaceUtglNative;